// Localização: frontend/src/components/Prontuario/Profissional/ProfissionalDocumentosTab.jsx (versão 1.0.0)
// Aba de Documentos do prontuário do profissional

import React from 'react';
import { FileText } from 'lucide-react';

const ProfissionalDocumentosTab = ({ profissionalId, prontuarioData, onRefresh }) => {
    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Documentos</h3>
            <div className="text-center py-8 text-gray-500">
                <FileText className="h-12 w-12 mx-auto mb-2 text-gray-400" />
                <p>Funcionalidade de documentos em desenvolvimento.</p>
            </div>
        </div>
    );
};

export default ProfissionalDocumentosTab;

